import React, { useState, createContext, useEffect } from "react";
import PropTypes from "prop-types";

export const LoaderContext = createContext({
  loader: false,
  activeRequests: [],
  showLoader: () => {},
  incrementRequests: () => {},
  decrementRequests: () => {},
  cancelRequest: () => {},
  cancelAllRequests: () => {},
});

const LoaderContextProvider = ({ children }) => {
  const [activeRequests, setActiveRequests] = useState([]);

  const incrementRequests = (cancel = null, path = null) => {
    const id = `${Date.now()}-${Math.random()}`;
    setActiveRequests((prev) => [...prev, { id, cancel, path }]);
    return id;
  };

  const decrementRequests = (id = null) => {
    setActiveRequests((prev) => {
      if (id) {
        return prev.filter((request) => request.id !== id);
      }

      // kompatybilność ze starym kodem:
      // decrementRequests() bez id usuwa jeden request
      return prev.slice(0, Math.max(prev.length - 1, 0));
    });
  };

  const cancelRequest = (id) => {
    setActiveRequests((prev) => {
      const request = prev.find((item) => item.id === id);

      if (request?.cancel) {
        request.cancel();
      }

      return prev.filter((item) => item.id !== id);
    });
  };

  const cancelAllRequests = () => {
    setActiveRequests((prev) => {
      prev.forEach((request) => {
        if (request?.cancel) {
          request.cancel();
        }
      });

      return [];
    });
  };

  const showLoader = (isLoading) => {
    if (isLoading) {
      incrementRequests();
    } else {
      decrementRequests();
    }
  };

  useEffect(() => {
    document.body.style.overflow =
      activeRequests.length > 0 ? "hidden" : "visible";

    return () => {
      document.body.style.overflow = "visible";
    };
  }, [activeRequests.length]);

  return (
    <LoaderContext.Provider
      value={{
        loader: activeRequests.length > 0,
        activeRequests,
        showLoader,
        incrementRequests,
        decrementRequests,
        cancelRequest,
        cancelAllRequests,
      }}
    >
      {children}
    </LoaderContext.Provider>
  );
};

LoaderContextProvider.propTypes = {
  children: PropTypes.node,
};

export default LoaderContextProvider;